import { sva } from 'styled-system/css';

export const customLabelRecipe = sva({
  slots: ['title', 'background'],
  base: {
    title: { color: 'purple-primary', textStyle: 'b4' },
    background: {
      backgroundColor: 'purple-6',
      borderRadius: '10px',
      display: 'inline-block',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0.1rem 1rem',
    },
  },
  variants: {
    color: {
      grey: {
        title: { color: 'purple-primary' },
        background: { backgroundColor: 'gray-2' },
      },
      blue: {
        title: { color: 'blue' },
        background: { backgroundColor: 'blue-2' },
      },
      purpleLight: {
        title: { color: 'purple-3' },
        background: { backgroundColor: 'purple-6' },
      },
      orange: {
        title: { color: 'orange' },
        background: { backgroundColor: 'orange-3' },
      },
      green: {
        title: { color: 'green-1' },
        background: { backgroundColor: 'green-4' },
      },
      pink: {
        title: { color: 'pink' },
        background: { backgroundColor: 'pink-2' },
      },
      black: {
        title: { color: 'black-3' },
        background: { backgroundColor: 'gray-3' },
      },
      yellow: {
        title: { color: 'yellow' },
        background: { backgroundColor: 'yellow-1' },
      },
    },
  },
});
